import { Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import Navigation from './Navigation'
import Footer from './Footer'
import Sidebar from './Sidebar'
import PushNotificationBanner from './PushNotificationBanner'
import PublicRecordingHeader from './PublicRecordingHeader'
import { LocationSettingsSync } from './HomeRedirect'
import { isPublicRecordingPath } from '../utils/publicRoutes'

function RoutePageFallback() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '40vh' }}>
      <CircularProgress />
    </Box>
  )
}

interface AppLayoutProps {
  children: React.ReactNode
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { pathname } = useLocation()
  const publicRecording = isPublicRecordingPath(pathname)

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <LocationSettingsSync />
      {publicRecording ? (
        <PublicRecordingHeader />
      ) : (
        <>
          <Navigation />
          <PushNotificationBanner />
        </>
      )}
      <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
        {!publicRecording && <Sidebar />}
        <Box component="main" sx={{ flex: 1, minWidth: 0 }}>
          <Suspense fallback={<RoutePageFallback />}>{children}</Suspense>
        </Box>
      </Box>
      <Footer />
    </Box>
  )
}

export default AppLayout
